class LocationList {
  constructor() {
    this.Oid = [];
    this.BLOBOid = [];
    this.BlkOfBusId = [];
    this.BlkOfBusName = [];
    this.ClientOid = [];
    this.ClientId = [];
    this.ClientName = [];
    this.LocationOid = [];
    this.LocationName = [];
    this.Status = [];
    this.LocationListResp = null;
  }

  getOid(index) {
    return this.Oid[index];
  }

  setOid(index, Oid) {
    this.Oid[index] = Oid;
  }

  getBLOBOid(index) {
    return this.BLOBOid[index];
  }

  setBLOBOid(index, Oid) {
    this.BLOBOid[index] = Oid;
  }

  getBlkOfBusId(index) {
    return this.BlkOfBusId[index];
  }

  setBlkOfBusId(index, BlkOfBusId) {
    this.BlkOfBusId[index] = BlkOfBusId;
  }
  getBlkOfBusName(index) {
    return this.BlkOfBusName[index];
  }

  setBlkOfBusName(index, BlkOfBusName) {
    this.BlkOfBusName[index] = BlkOfBusName;
  }

  getClientOid(index) {
    return this.ClientOid[index];
  }

  setClientOid(index, Oid) {
    this.ClientOid[index] = Oid;
  }

  getClientId(index) {
    return this.ClientId[index];
  }

  setClientId(index, ClientId) {
    this.ClientId[index] = ClientId;
  }

  getClientName(index) {
    return this.ClientName[index];
  }

  setClientName(index, ClientName) {
    this.ClientName[index] = ClientName;
  }

  getLocationOid(index) {
    return this.LocationOid[index];
  }

  setLocationOid(index, Oid) {
    this.LocationOid[index] = Oid;
  }
  getLocationName(index) {
    return this.LocationName[index];
  }

  setLocationName(index, LocationName) {
    this.LocationName[index] = LocationName;
  }

  getDescription(index) {
    return this.Description[index];
  }

  setDescription(index, Description) {
    this.Description[index] = Description;
  }

  getStatus(index) {
    return this.Status[index];
  }

  setStatus(index, Status) {
    this.Status[index] = Status;
  }

  getLocationListResp() {
    return this.LocationListResp;
  }

  setLocationListResp(LocationListResp) {
    this.LocationListResp = LocationListResp;
  }

  resetLocationList() {
    this.Oid = [];
    this.BLOBOid = [];
    this.BlkOfBusId = [];
    this.BlkOfBusName = [];
    this.ClientOid = [];
    this.ClientId = [];
    this.ClientName = [];
    this.LocationOid = [];
    this.LocationName = [];
    this.Status = [];
    this.LocationListResp = null;
  }
}
export default new LocationList();
